<template>
    <table class="w-full">
        <tbody class="striped">
            <tr class="not_striped">
                <th colspan="7" class="pt-6 text-left text-2xl text-gray-dark font-bold" :class="{'pb-2': !order.allow_substitutions}">
                    Order Details
                </th>
            </tr>
            <tr v-if="isAdmin || type != 'invoice'" class="not_striped">
                <th colspan="7" class="pb-2 text-left">
                    <div class="font-bold text-gray-dark text-lg">
                        SUBSTITUTIONS<span v-if="!order.allow_substitutions"> NOT</span> ALLOWED
                    </div>
                </th>
            </tr>
            <tr class="not_striped border-b border-gray">
                <th v-if="type == 'invoice'" class="py-1 text-center px-2 w-1">
                    <p v-if="isAdmin">QC</p>
                </th>
                <th v-else class="py-1 text-center px-2 w-1">QC</th>
                <th class="py-1 text-left px-2">Qty</th>
                <th class="py-1 text-left pl-4 pr-2 w-1/5">UofM</th>
                <th class="py-1 text-left px-2">Item</th>
                <th class="py-1 text-center px-2">Zone</th>
                <th v-if="!order.gift && (type == 'invoice' || (order.customer && order.customer.show_picksheet_pricing))" class="py-1 px-2 text-center">Price</th>
                <th v-if="!order.gift && (type == 'invoice' || (order.customer && order.customer.show_picksheet_pricing))" class="py-1 px-2 text-right whitespace-nowrap">Line Total</th>
            </tr>
            <template v-for="(item, index) in orderItemsSortedByZone(order.order_items)" :key="index">
                <!-- Parent Item -->
                <tr
                    class="border-b border-gray"
                    :class="{
                        'text-gray-500': type != 'invoice' && orderItemsInlineSubitems(item).length > 0,
                    }"
                    :style="{
                        'border-bottom': type != 'invoice' && orderItemsInlineSubitems(item).length == 0 && isLastItemInZone(index) ? '2px solid #AAA' : null,
                    }"
                    >
                    <td v-if="type == 'invoice'" class="text-center px-2">
                        <input v-if="isAdmin" type="checkbox" class="border-gray-dark rounded-sm" disabled>
                    </td>
                    <td v-else class="text-center px-2"><input type="checkbox" class="border-gray-dark rounded-sm" disabled></td>
                    <td class="text-center px-2">{{ item.quantity }}</td>
                    <td v-if="type == 'outlet_order'" class="text-left whitespace-nowrap pl-4 pr-2"><span v-html="boldProductHighlights(item.description, item.product.picksheet_highlights)"/></td>
                    <td v-else class="text-left whitespace-nowrap pl-4 pr-2"><span v-html="boldProductHighlights(item.size, item.product.picksheet_highlights)"/></td>
                    <td v-if="type == 'outlet_order'" class="text-left px-2">
                        <span v-html="boldProductHighlights(item.title, item.product.picksheet_highlights)"/>
                        <span v-if="item.description_alt && !item.description_alt.match(/\n/g)"> - <span v-html="boldProductHighlights(item.description_alt, item.product.picksheet_highlights)"/></span>
                        <div v-if="item.description_alt && item.description_alt.match(/\n/g)" class="text-xs italic"><span v-html="boldProductHighlights(item.description_alt, item.product.picksheet_highlights)"/></div>
                        <div v-if="item.contents && shown_subitems(item).length == 0" class="text-xs italic"><span v-html="boldProductHighlights(item.contents, item.product.picksheet_highlights)"/></div>
                    </td>
                    <td v-else class="text-left px-2">
                        <span v-html="boldProductHighlights(item.title, item.product.picksheet_highlights)"/>
                        <span v-if="item.description"> - <span v-html="boldProductHighlights(item.description, item.product.picksheet_highlights)"/></span>
                        <div v-show="item.product_notes" class="text-xs italic"><span v-html="boldProductHighlights(item.product_notes, item.product.picksheet_highlights)"/></div>
                    </td>
                    <td v-if="type == 'outlet_order'" class="text-center px-2">
                        <span v-if="item.product && !item.product.category.subitems_on_separate_picksheet">{{ item.product.retail_zone }}</span>
                    </td>
                    <td v-else-if="order.customer?.type == 'School'" class="text-center px-2">
                        <span v-if="item.product && !item.product.category.subitems_on_separate_picksheet">{{ item.product.school_zone }}</span>
                    </td>
                    <td v-else class="text-center px-2">
                        <span v-if="item.product && !item.product.category.subitems_on_separate_picksheet">{{ item.product.zone }}</span>
                    </td>
                    <td v-if="!order.gift && (type == 'invoice' || (order.customer && order.customer.show_picksheet_pricing))" class="text-right px-2">{{ toCurrency(item.price) }}</td>
                    <td v-if="!order.gift && (type == 'invoice' || (order.customer && order.customer.show_picksheet_pricing))" class="text-right px-2">{{ toCurrency(item.quantity * item.price) }}</td>
                </tr>
                <!-- Inline Subitems -->
                <template v-if="type != 'invoice'">
                <tr  v-for="(subitem, si_index) in orderItemsInlineSubitems(item)" class="border-b border-gray" :key="index + '_' + si_index + '_subitem'">
                    <td class="combo_with_integrated_subitems text-center px-2"><input type="checkbox" class="border-gray-dark rounded-sm" disabled></td>
                    <td class="combo_with_integrated_subitems text-center px-2">{{ subitem.quantity }}</td>
                    <td v-if="type == 'outlet_order'" class="combo_with_integrated_subitems text-left whitespace-nowrap pl-4 pr-2"><span v-html="boldProductHighlights(subitem.description, subitem.product.picksheet_highlights)"/></td>
                    <td v-else class="combo_with_integrated_subitems text-left whitespace-nowrap pl-4 pr-2"><span v-html="boldProductHighlights(subitem.size, subitem.product.picksheet_highlights)"/></td>
                    <td v-if="type == 'outlet_order'" class="combo_with_integrated_subitems text-left px-2">
                        <span v-html="boldProductHighlights(subitem.title, subitem.product.picksheet_highlights)"/>
                        <span v-if="subitem.description && subitem.contents"> - <span v-html="boldProductHighlights(subitem.description)"/></span>
                        <span v-if="subitem.description_alt && !subitem.description_alt.match(/\n/g)"> - <span v-html="boldProductHighlights(subitem.description_alt, subitem.product.picksheet_highlights)"/></span>
                        <span v-if="subitem.description && !subitem.contents"> - <span v-html="boldProductHighlights(subitem.description, item.product.picksheet_highlights)"/></span>
                        <div v-if="subitem.description_alt && subitem.description_alt.match(/\n/g)" class="text-xs italic"><span v-html="boldProductHighlights(subitem.description_alt, item.product.picksheet_highlights)"/></div>
                        <div v-if="subitem.contents" class="text-xs italic"><span v-html="boldProductHighlights(subitem.contents, subitem.product.picksheet_highlights)"/></div>
                    </td>
                    <td v-else class="combo_with_integrated_subitems text-left px-2">
                        <span v-html="boldProductHighlights(subitem.title, subitem.product.picksheet_highlights)"/>
                        <span v-if="subitem.description"> - <span v-html="boldProductHighlights(subitem.description, subitem.product.picksheet_highlights)"/></span>
                        <div v-show="subitem.product_notes" class="text-xs italic"><span v-html="boldProductHighlights(subitem.product_notes, subitem.product.picksheet_highlights)"/></div>
                    </td>
                    <td v-if="type == 'outlet_order'" class="combo_with_integrated_subitems text-center px-2">
                        {{ subitem.product.retail_zone }}
                    </td>
                    <td v-else-if="order.customer?.type == 'School'" class="combo_with_integrated_subitems text-center px-2">
                        {{ subitem.product.school_zone }}
                    </td>
                    <td v-else class="combo_with_integrated_subitems text-center px-2">
                        {{ subitem.product.zone }}
                    </td>
                </tr>
                </template>
            </template>
            <tr class="not_striped">
                <td class="px-2">
                    <div v-if="isAdmin">
                        <input type="text" class="w-full signature" disabled>
                        <div class="text-sm whitespace-nowrap">QC Initials</div>
                    </div>
                </td>
                <td class="text-center px-2">{{ order.item_count_picksheet }}</td>
                <td rowspan="6" style="border-bottom:none;" class="align-top">
                    <div v-if="type == 'outlet_order'" class="text-center">
                        <img src="/images/quality-guaranteed.png" alt="quality" id="quality" style="width:100%;max-width:300px;" />
                    </div>
                </td>
                <th v-if="!order.gift && (type == 'invoice' || (order.customer && order.customer.show_picksheet_pricing))" colspan="3" class="text-right px-2">Subtotal:</th>
                <td v-if="!order.gift && (type == 'invoice' || (order.customer && order.customer.show_picksheet_pricing))" class="text-right px-2">{{ toCurrency(subtotal(order)) }}</td>
            </tr>
            
            <template v-if="!order.gift && (type == 'invoice' || (order.customer && order.customer.show_picksheet_pricing))">
            <tr v-if="delivery_fee(order) > 0" class="not_striped">
                <th colspan="6" class="text-right px-2">Delivery Fee:</th>
                <td class="text-right px-2">{{ toCurrency(delivery_fee(order)) }}</td>
            </tr>
            <tr v-if="tax(order) > 0 || tax(order) < 0" class="not_striped">
                <th colspan="6" class="text-right px-2">Tax:</th>
                <td class="text-right px-2">{{ toCurrency(tax(order)) }}</td>
            </tr>
            <tr v-if="type == 'outlet_order' && order.promo_code_amount > 0" class="not_striped">
                <th colspan="6" class="text-right px-2">Promo Code Discount:</th>
                <td class="text-right px-2">-{{ toCurrency(parseFloat(order.promo_code_amount)) }}</td>
            </tr>
            <tr v-if="type != 'outlet_order' && order.applied_credit_amount > 0" class="not_striped">
                <th colspan="6" class="text-right px-2">Prepaid:</th>
                <td class="text-right px-2">{{ toCurrency(parseFloat(order.applied_credit_amount)) }}</td>
            </tr>
            <tr class="not_striped">
                <th colspan="6" class="text-right px-2">Total:</th>
                <td class="text-right px-2">{{ toCurrency(total(order)) }}</td>
            </tr>
            <tr v-if="type == 'invoice' && order.payment_status == 'paid' && order.moneris_receipt_amount > 0" class="not_striped">
                <th colspan="6" class="text-right px-2">Paid:</th>
                <td class="text-right px-2">{{ toCurrency(parseFloat(order.moneris_receipt_amount)) }}</td>
            </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
import UseUserAuth from '@/Composables/UseUserAuth';
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    components: {
    },

    setup () {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);

        return { isAdmin }
    },

    props: ['order', 'type'],

    methods: {
        subtotal(order) {
            return order.order_items.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.quantity * currentValue.price);
            }, 0);
        },
        
        tax(order) {
            if (order.customer){
                if (order.customer.tax_exempt) return 0;
            }

            let taxRatio = 0.13;
            let tax = order.order_items.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.tax === true ?  (currentValue.quantity * currentValue.price * taxRatio) : 0);
            }, 0);
            return tax + (this.delivery_fee(order) * taxRatio);
        },

        total(order) {
            return this.subtotal(order) + this.tax(order) + this.delivery_fee(order) - parseFloat(order.promo_code_amount ?? 0) - parseFloat(order.applied_credit_amount ?? 0);
        },

        delivery_fee(order){
            return  order.delivery_fee ? parseFloat(order.delivery_fee) : 0;
        },
        
        shown_subitems (order_item) {
            return order_item.subitems.filter(subitem => !order_item.product.subproducts.find(subproduct => subproduct.subproduct_id == subitem.product_id) || !order_item.product.subproducts.find(subproduct => subproduct.subproduct_id == subitem.product_id).hidden_from_customer)
        },

        orderItemsInlineSubitems(order_item)
        {
            if (order_item.product.include_subitems_on_picksheet && order_item.product.category.subitems_on_separate_picksheet == 0 && order_item.subitems.length > 0)
            {
                return this.orderItemsSortedByZone(this.shown_subitems(order_item));
            }
            return [];
        },

        orderItemsSortedByZone(order_items)
        {
            let zone_type = 'zone'
            let subzone_type = 'subzone'
            if(this.type === 'outlet_order'){
                zone_type = 'retail_zone'
                subzone_type = 'retail_subzone'
            }else if(this.order.customer?.type === 'School'){
                zone_type = 'school_zone'
                subzone_type = 'school_subzone'
            }

            return order_items.sort((a, b) => {
                if (a.product[zone_type] < b.product[zone_type]) return -1;
                else if (a.product[zone_type] > b.product[zone_type]) return 1;
                else {
                    if (a.product[subzone_type] < b.product[subzone_type]) return -1;
                    else if (a.product[subzone_type] > b.product[subzone_type]) return 1;
                    return 0;
                }
            });
        },

        orderItemsWithSubitemsOnSeparatePicksheet(order)
        {
            return order.order_items.filter(oi => (oi.product.include_subitems_on_picksheet && oi.product.category.subitems_on_separate_picksheet == 1 && this.shown_subitems(oi).length > 0));
        },

        isLastItemInZone (index) {
            let current_item = this.order.order_items[index];
            let next_item = this.order.order_items[index + 1];

            if (this.type == 'outlet_order') return next_item !== undefined && current_item.product.retail_zone != next_item.product.retail_zone
            else return next_item !== undefined && current_item.product.zone != next_item.product.zone
        },

        boldProductHighlights(string, wordsToHighlight = "") {
            if (this.type == 'invoice' || string == null) return string;
            let wordsToHighlightArr = []

            if (wordsToHighlight != null){
                wordsToHighlightArr = wordsToHighlight.split(',').map(w =>w.trim());
            }
            wordsToHighlightArr.push("case") //always hightlight "case"
            const regex = new RegExp(`\\b(${wordsToHighlightArr.join('|')})\\b`, 'gi');
            return string.replace(regex, match => `<b>${match}</b>`);
        }
    },
}

</script>
